var map = {
	"./R0.png": 133,
	"./R10.png": 220,
	"./R100.gif": 344,
	"./R100.png": 221,
	"./R20.png": 222,
	"./R30.png": 223,
	"./R40.png": 224,
	"./R50.png": 225,
	"./R60.png": 226,
	"./R70.png": 227,
	"./R80.png": 228,
	"./R90.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;